import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'ruleset',
    path: 'max_discount.type',
    viewPath: props.viewPath,
  })
  let selected = useDataValue({
    context: 'ruleset',
    path: 'max_discount.type',
    viewPath: props.viewPath,
  })
  let typeId = useDataValue({
    context: 'type',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onChange() {
    if (typeId === selected) return
    change(typeId)
  }
}
